import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import HomeBannerData from "../../components/admincomponents/HomeBannerData";

function HomePageBannerData({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <HomeBannerData />            
    </>
  );
}

export default HomePageBannerData;
